const data = {
  title: "Floor 4-9",
  musicTrack: "MUSIC_BATTLE",
  story: "Ciabatta appears! Salty as ever.",
  theme: "GRAY",
  timeLimitSeconds: 120,
  tilesWidth: 11,
  tilesHeight: 21,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 6,
      y: 4,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 2,
      y: 4,
    },
    {
      type: "WALL",
      x: 1,
      y: 2,
    },
    {
      type: "WALL",
      x: 2,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 3,
      y: 2,
    },
    {
      type: "WALL",
      x: 5,
      y: 2,
    },
    {
      type: "WALL",
      x: 6,
      y: 2,
    },
    {
      type: "WALL",
      x: 7,
      y: 2,
    },
    {
      type: "WALL",
      x: 1,
      y: 6,
    },
    {
      type: "WALL",
      x: 2,
      y: 6,
    },
    {
      type: "WALL",
      x: 3,
      y: 6,
    },
    {
      type: "WALL",
      x: 5,
      y: 6,
    },
    {
      type: "WALL",
      x: 7,
      y: 6,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "WALL",
      x: 4,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 6,
    },
    {
      type: "WALL",
      x: 8,
      y: 5,
    },
    {
      type: "WALL",
      x: 4,
      y: 6,
    },
    {
      type: "WALL",
      x: 9,
      y: 2,
    },
    {
      type: "WALL",
      x: 10,
      y: 2,
    },
    {
      type: "WALL",
      x: 11,
      y: 2,
    },
    {
      type: "WALL",
      x: 9,
      y: 6,
    },
    {
      type: "WALL",
      x: 10,
      y: 6,
    },
    {
      type: "WALL",
      x: 11,
      y: 6,
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 4,
    },
    {
      type: "WALL",
      x: 8,
      y: 7,
    },
    {
      type: "WALL",
      x: 4,
      y: 7,
    },
    {
      type: "WALL",
      x: 4,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 10,
    },
    {
      type: "WALL",
      x: 5,
      y: 10,
    },
    {
      type: "WALL",
      x: 3,
      y: 10,
    },
    {
      type: "WALL",
      x: 4,
      y: 11,
    },
    {
      type: "WALL",
      x: 8,
      y: 10,
    },
    {
      type: "WALL",
      x: 8,
      y: 9,
    },
    {
      type: "WALL",
      x: 7,
      y: 10,
    },
    {
      type: "WALL",
      x: 9,
      y: 10,
    },
    {
      type: "WALL",
      x: 11,
      y: 10,
    },
    {
      type: "WALL",
      x: 1,
      y: 10,
    },
    {
      type: "WALL",
      x: 4,
      y: 13,
    },
    {
      type: "WALL",
      x: 4,
      y: 14,
    },
    {
      type: "WALL",
      x: 3,
      y: 14,
    },
    {
      type: "WALL",
      x: 5,
      y: 14,
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 8,
    },
    {
      type: "TELEPORT",
      x: 6,
      y: 8,
    },
    {
      type: "TELEPORT",
      x: 2,
      y: 8,
    },
    {
      type: "KEY",
      x: 8,
      y: 4,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 8,
      y: 11,
    },
    {
      type: "WALL",
      x: 8,
      y: 13,
    },
    {
      type: "WALL",
      x: 8,
      y: 14,
    },
    {
      type: "WALL",
      x: 9,
      y: 14,
    },
    {
      type: "WALL",
      x: 11,
      y: 14,
    },
    {
      type: "WALL",
      x: 8,
      y: 15,
    },
    {
      type: "WALL",
      x: 4,
      y: 15,
    },
    {
      type: "WALL",
      x: 4,
      y: 17,
    },
    {
      type: "WALL",
      x: 4,
      y: 18,
    },
    {
      type: "WALL",
      x: 3,
      y: 18,
    },
    {
      type: "WALL",
      x: 5,
      y: 18,
    },
    {
      type: "WALL",
      x: 4,
      y: 19,
    },
    {
      type: "WALL",
      x: 8,
      y: 18,
    },
    {
      type: "WALL",
      x: 7,
      y: 18,
    },
    {
      type: "WALL",
      x: 9,
      y: 18,
    },
    {
      type: "WALL",
      x: 8,
      y: 19,
    },
    {
      type: "WALL",
      x: 8,
      y: 17,
    },
    {
      type: "WALL",
      x: 1,
      y: 18,
    },
    {
      type: "WALL",
      x: 11,
      y: 18,
    },
    {
      type: "WALL",
      x: 8,
      y: 21,
    },
    {
      type: "WALL",
      x: 4,
      y: 21,
    },
    {
      type: "LOCK",
      x: 10,
      y: 18,
      color: "BLUE",
    },
    {
      type: "CONVEYOR",
      x: 8,
      y: 20,
      direction: "LEFT",
    },
    {
      type: "WALL",
      x: 8,
      y: 8,
    },
    {
      type: "FIRE",
      x: 1,
      y: 11,
    },
    {
      type: "FIRE",
      x: 2,
      y: 12,
    },
    {
      type: "FIRE",
      x: 3,
      y: 13,
    },
    {
      type: "FIRE",
      x: 1,
      y: 13,
    },
    {
      type: "FIRE",
      x: 1,
      y: 12,
    },
    {
      type: "FIRE",
      x: 2,
      y: 13,
    },
    {
      type: "FIRE",
      x: 3,
      y: 12,
    },
    {
      type: "FIRE",
      x: 3,
      y: 11,
    },
    {
      type: "FIRE",
      x: 2,
      y: 11,
    },
    {
      type: "WATER",
      x: 5,
      y: 15,
    },
    {
      type: "WATER",
      x: 5,
      y: 16,
    },
    {
      type: "WATER",
      x: 5,
      y: 17,
    },
    {
      type: "WATER",
      x: 6,
      y: 17,
    },
    {
      type: "WATER",
      x: 7,
      y: 17,
    },
    {
      type: "WATER",
      x: 6,
      y: 16,
    },
    {
      type: "WALL",
      x: 4,
      y: 8,
    },
    {
      type: "LOCK",
      x: 8,
      y: 12,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 10,
      y: 10,
    },
    {
      type: "KEY",
      x: 10,
      y: 12,
      color: "BLUE",
    },
    {
      type: "LOCK",
      x: 2,
      y: 10,
      color: "BLUE",
    },
    {
      type: "THIEF",
      x: 10,
      y: 14,
    },
    {
      type: "WALL",
      x: 1,
      y: 14,
    },
    {
      type: "LOCK",
      x: 4,
      y: 4,
      color: "BLUE",
    },
    {
      type: "CHIP",
      x: 2,
      y: 12,
    },
    {
      type: "CHIP",
      x: 2,
      y: 20,
    },
    {
      type: "THIEF",
      x: 4,
      y: 12,
    },
    {
      type: "WATER",
      x: 6,
      y: 15,
    },
    {
      type: "WATER",
      x: 7,
      y: 15,
    },
    {
      type: "WATER",
      x: 7,
      y: 16,
    },
    {
      type: "WATER_PICKUP",
      x: 10,
      y: 16,
    },
    {
      type: "CONVEYOR",
      x: 8,
      y: 16,
      direction: "RIGHT",
    },
    {
      type: "FIRE_BOOTS",
      x: 2,
      y: 16,
    },
    {
      type: "WALL",
      x: 7,
      y: 14,
    },
    {
      type: "TELEPORT",
      x: 1,
      y: 1,
    },
    {
      type: "TELEPORT",
      x: 11,
      y: 1,
    },
    {
      type: "CHIP",
      x: 6,
      y: 1,
    },
    {
      type: "ICE_BOOTS",
      x: 6,
      y: 12,
    },
    {
      type: "THIEF",
      x: 4,
      y: 20,
    },
    {
      type: "TELEPORT",
      x: 10,
      y: 20,
    },
    {
      type: "CHIP",
      x: 6,
      y: 20,
    },
    {
      type: "LOCK",
      x: 2,
      y: 14,
      color: "GREEN",
    },
    {
      type: "ICE",
      x: 2,
      y: 1,
    },
    {
      type: "ICE",
      x: 3,
      y: 1,
    },
    {
      type: "ICE",
      x: 5,
      y: 1,
    },
    {
      type: "ICE",
      x: 6,
      y: 1,
    },
    {
      type: "ICE",
      x: 7,
      y: 1,
    },
    {
      type: "ICE",
      x: 8,
      y: 1,
    },
    {
      type: "ICE",
      x: 9,
      y: 1,
    },
    {
      type: "ICE",
      x: 10,
      y: 1,
    },
    {
      type: "ENEMY_SPAWN",
      x: 9,
      y: 1,
      enemyType: "CIABATTA",
    },
    {
      type: "WALL",
      x: 6,
      y: 6,
    },
    {
      type: "ICE",
      x: 4,
      y: 1,
    },
  ],
};

export default data;
